import { TDefaultAddressResponse } from "../models/defaultAddress";
import type { TDefaultAddress } from "../types";

const mapDefaultAddressResponse = (response: TDefaultAddressResponse): TDefaultAddress => ({
  id: response.id,
  contactName: response.contactName,
  contactEmail: response.contactEmail,
  contactPhone: response.contactPhone,
  countryCode: response.countryCode,
  country: response.country,
  city: response.city,
  returnLocker: response.returnLocker,
  returnLockerId: response.returnLockerId,
  street: response.street,
  streetNumber: response.streetNumber,
  flatNo: response.flatNo,
  zip: response.zip,
});
export default mapDefaultAddressResponse;
